import { normalizarRotulosDuplicados } from 'src/util/string/normalizarRotulosDuplicados';
import { addBreackLines, addMaxLength, capitalizeText } from '../../../../../util/formatters/stringNormalizer';
import { toEchartData } from '../dataProcessor';
import getTooltipFormatter from './tooltipFormatter';

function getOptions(echartData, theme, chartFontSize = 14, disabledLegends = [], highlitIndex) {
  const { legends, points, lines } = echartData;

  const sourceResults = lines.map((line) => [
    line.name,
    ...line.results.map((result) => result.value),
  ]);

  const formattedPoints = addBreackLines(points, 10);

  const pontosNormalizados = normalizarRotulosDuplicados("whitespace", ...formattedPoints);

  const dataset = {
    source: [['Pesquisas', ...pontosNormalizados], ...sourceResults],
  };

  const series = lines.map((line, index) => ({
    type: 'bar',
    seriesLayoutBy: 'row',
    name: line.name,
    label: {
      show: true,
      position: 'top',
      formatter: (params) => `${params.data[params.seriesIndex + 1]}%`,
      textStyle: {
        color: theme.label.text,
        fontSize: chartFontSize,
      },
    },
    ...(highlitIndex === undefined ? {} : {
      itemStyle: index === highlitIndex ? {
        borderType: theme.highlitedItemBorderType,
        borderColor: theme.highlitedItemBorderColor,
        borderWidth: theme.highlitedItemBorderWidth,
      } : null,
    }),
    
  }));

  const legendWithLegend = legends.map((legend) => ({
    ...legend,
    icon: 'circle',
  }));

  // persistencia de estado das legendas
  const selectedLegends = {};
  legendWithLegend.forEach(({ name }) => {
    selectedLegends[name] = !disabledLegends.includes(name);
  });

  const formatter = getTooltipFormatter(echartData);

  return {
    visibleLegends: legendWithLegend,
    color: theme.colors,
    tooltip: {
      trigger: 'axis',
      formatter,
      axisPointer: {
        type: 'shadow',
      },
      confine: true,
    },
    legend: {
      data: legendWithLegend,
      selected: selectedLegends,
      type: 'scroll',
      textStyle: {
        color: theme.legend.color,
        fontSize: chartFontSize,
        fontFamily: 'Roboto, sans-serif'
      },
      formatter: capitalizeText,
      pageTextStyle: {
        color: theme.legend.pagination.text.color,
      },
      pageIconColor: theme.legend.pagination.buttons.color,
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      show: true,
      axisTick: {
        alignWithLabel: true,
      },
      axisLabel: {
        formatter: (value) => addMaxLength(value, 20),
        textStyle: {
          color: theme.axis.x.label,
        },
        rotate: 45,
      },
    },
    yAxis: {
      type: 'value',
    },
    dataset,
    series,
  };
}

export default function toEchartOption(resultadosEvolutivos, theme, fontSize, disabledLegends = [], highlitIndex) {
  const echartData = toEchartData(resultadosEvolutivos);
  const options = getOptions(echartData, theme, fontSize, disabledLegends, highlitIndex);

  return options;
}
